<div
	*ngIf="hideForms"
	class="w-full h-full flex flex-col flex-1 justify-center items-center"
>
	<div class="empty-state-image">
		<img src="assets/images/empty-states/forms.svg" />
	</div>
	<h3 class="mt-10">Add a mortgage to view forms</h3>
	<p class="mt-3">To view forms you have add a mortgage</p>
	<div class="mt-5">
		<app-button [icon]="ICON.ADD" size="small" (click)="navigateToMortgage()"
			>Add mortgage</app-button
		>
	</div>
</div>

<ng-container *ngIf="!hideForms">
	<div class="forms-grid-container">
		<div class="h-full flex flex-col overflow-auto">
			<h2 class="mb-4">Forms</h2>
			<div class="min-h-0 overflow-auto">
				<app-container
					class="my-2"
					*ngIf="matter?.fileType == matterFileTypes.PURCHASE"
				>
					<h4 class="mb-5">LTT and MLTT Forms</h4>
					<app-anchor
						class="mt-3"
						type="pill"
						[url]="baseRoute + '/' + formTypes.LTT_AFFIDAVIT_FORM"
						>LTT Affidavit form</app-anchor
					>
					<app-anchor
						class="mt-3"
						type="pill"
						[url]="baseRoute + '/' + formTypes.LTT_REBATE_FORM"
						>LTT Rebate form</app-anchor
					>

					<app-anchor
						class="mt-3"
						type="pill"
						[url]="baseRoute + '/' + formTypes.MLTT_AFFIDAVIT_FORM"
						>MLTT Affidavit form</app-anchor
					>

					<app-anchor
						class="mt-3"
						type="pill"
						[url]="baseRoute + '/' + formTypes.MLTT_REBATE_FORM"
						>MLTT Rebate form</app-anchor
					>
				</app-container>

				<app-container
					*ngIf="
						matter?.fileType === matterFileTypes.SALE ||
						matter?.fileType === matterFileTypes.PURCHASE
					"
				>
					<h4 class="mb-5">GST/HST new housing</h4>
					<app-anchor
						type="pill"
						[url]="baseRoute + '/' + formTypes.ON_GST_NEW_HOUSING_REBATE"
						>New house rebate application</app-anchor
					>
					<app-anchor
						class="mt-3"
						type="pill"
						[url]="baseRoute + '/' + formTypes.ON_GST_NEW_REBATE_RENTAL"
						>Rental rebate application</app-anchor
					>
					<app-anchor
						class="mt-3"
						type="pill"
						[url]="baseRoute + '/' + formTypes.ON_GST_190_APPENDIX_A"
						>Rebate application - Appendix A</app-anchor
					>
					<app-anchor
						class="mt-3"
						type="pill"
						[url]="baseRoute + '/' + formTypes.ON_GST_190_CALCULATION_WS"
						>GST 190 Calculation worksheet</app-anchor
					>
					<app-anchor
						class="mt-3"
						type="pill"
						[url]="baseRoute + '/' + formTypes.ON_GST_190_REBATE_SCHEDULE"
						>GST 190 Ontario rebate schedule</app-anchor
					>
					<app-anchor
						class="mt-3"
						type="pill"
						[url]="baseRoute + '/' + formTypes.ON_GST_524_REBATE_SCHEDULE"
						>GST 524 Ontario rebate schedule</app-anchor
					>
				</app-container>

				<app-container
					class="mt-2"
					*ngIf="matter?.fileType == matterFileTypes.PURCHASE"
				>
					<h4 class="mb-5">Purchase</h4>
					<app-anchor
						type="pill"
						[url]="
							baseRoute +
							'/' +
							formTypes.STANDALONE_PURCHASE_PRESCRIBED_INFORMATION_FORM
						"
						>Prescribed information</app-anchor
					>
				</app-container>

				<ng-container *ngFor="let mortgage of mortgagesWithForms">
					<app-lender-forms-mortgage-card
						[mortgage]="mortgage"
					></app-lender-forms-mortgage-card>
				</ng-container>
			</div>
		</div>
		<div class="flex-1">
			<router-outlet></router-outlet>
		</div>
	</div>
</ng-container>
